import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { BookingItemComponent } from './smr-booking-item.component';
import { CircleTextAvatarComponent} from '../shared/circle-text-avatar/circle-text-avatar.component';
// import { SalonMonsterDatePipe } from '../..//pipes/salonmonster-date.pipe';
import {SharedModule} from '../../shared.module';
import { CommonModule } from "@angular/common";
import {RouterModule} from '@angular/router';
import { CircleTextAvatarComponentModule } from '../shared/circle-text-avatar/circle-text-avatar.module';
@NgModule({
    declarations: [
        BookingItemComponent,
    ],
    imports: [
        IonicModule,
        SharedModule,
        CommonModule,
        RouterModule,
        CircleTextAvatarComponentModule
    ],
    exports: [
        BookingItemComponent,
    ],
    providers: []
})
export class SalonMonsterBookingItemModule {}
